import React, { useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db, auth } from "../firebase/firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import "../styles/forms.css";

function NewPostForm() {
  const [user, loading, error] = useAuthState(auth);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user) return; // Protect if the user is not logged in

    try {
      const userDocRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        const userData = userDoc.data();

        await addDoc(collection(db, "posts"), {
          name: userData.username || "",
          title,
          description,
          timestamp: serverTimestamp(),
          dorm: userData.dorm || "",
          roomNumber: userData.roomNumber || "",
        });

        navigate("/feed");
      } else {
        console.error("User document not found");
      }
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  return (
    <div className="siteWrapper">
      <div className="new-post-form-container">
        {loading ? (
          <p>Loading user data...</p>
        ) : (
          <form onSubmit={handleSubmit} className="new-post-form">
            <h2>Create New Post</h2>
            <div>
              <label>Title</label>
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </div>
            <div>
              <label>Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              ></textarea>
            </div>
            <button type="submit" className="button">Submit</button>
          </form>
        )}
      </div>
    </div>
  );
}

export default NewPostForm;
